<template>
  <div class="wrapper">
    <header>
      <div class="logo-container">
        <img :src="logo" alt="Easy agency logo" :style="{width: '116px'}" />
      </div>
    </header>
    <main>
      <div class="content">
        <div class="headers">
          <h1>Page Not Found</h1>
          <h2>404</h2>
        </div>
        <p>Sorry, the page you are looking for cannot be found. Please check the URL or return to the home page for further navigation.</p>
        <b-button
          variant="primary"
          class="button home-button"
          tag="router-link"
          :to="{ name: ROUTES.HOME.name }"
        >
          Home page
        </b-button>
      </div>
    </main>
    <footer>
      © {{year}} EasyAgency. All rights reserved.
    </footer>
  </div>
</template>

<script>
import logo from '@/assets/logo.webp'

export default {
  name: 'NotFound404',
  data () {
    return {
      logo
    }
  },
  computed: {
    year () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-bottom: 42px;
}

header {
  display: flex;
  height: $header-min-height;
  background-color: #fff;

  .logo-container {
    display: flex;
    align-items: center;
    margin: 0 14px;

    img {
      display: block;
    }
  }
}

main {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    width: 533px;
    text-align: center;

    .headers {
      display: flex;
      flex-direction: column-reverse;

      h2 {
        margin-bottom: 16px;
        font-size: 128px;
        font-weight: 700;
        line-height: 147.07px;
      }

      h1 {
        font-size: 40px;
        font-weight: 700;
        line-height: 48px;
      }
    }

    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: $fontColor2;
    }

  }
}

.home-button {
  display: inline-flex;
}

footer {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 18.38px;
  color: $fontColor2;
}
</style>
